<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-money-check"></i> Update Booking Details</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form">
    <div class="row">
      <div class="offset-2 col-sm-8">
        <app-select-search
          bindValue="id"
          bindLabel="name"
          [items]="rentals$ | async"
          [multiple]="false"
          [ctrl]="form.get('rentalId')"
          placeholder="Rentals"
          class="max-mat"
        ></app-select-search>
      </div>
    </div>

    <div class="row">
      <div class="offset-2 col-sm-4">
        <mat-form-field class="mat-block">
          <mat-select formControlName="adults" placeholder="Adults:">
            <mat-option *ngFor="let option of adultsOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="col-sm-4">
        <mat-form-field class="mat-block">
          <mat-select formControlName="children" placeholder="Children:">
            <mat-option *ngFor="let option of childrenOptions" [value]="option">{{ option }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="offset-2 col-sm-4">
        <mat-form-field class="mat-block">
          <input
            matInput
            placeholder="Arrive:"
            [matDatepicker]="guestArrivePicker"
            [required]="true"
            [min]="minDateDefault"
            [max]="maxArriveDate.value || maxDateDefault"
            (focus)="guestArrivePicker.open()"
            formControlName="guestArrive"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="guestArrivePicker"></mat-datepicker-toggle>
          <mat-datepicker #guestArrivePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-sm-4">
        <mat-form-field class="mat-block">
          <input
            matInput
            placeholder="Depart:"
            [matDatepicker]="guestDepartPicker"
            [min]="minDepartDate.value || minDateDefault"
            [max]="maxDateDefault"
            [required]="true"
            (focus)="guestDepartPicker.open()"
            formControlName="guestDepart"
            readonly
          />
          <mat-datepicker-toggle matSuffix [for]="guestDepartPicker"></mat-datepicker-toggle>
          <mat-datepicker #guestDepartPicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="offset-2 col-sm-4">
        <p style="margin-top: 28px">
          {{ inquiry.guestDepart | dateDiff: inquiry.guestArrive }} Days,
          {{ inquiry.guestDepart | dateDiff: inquiry.guestArrive:'nights' }} Nights
        </p>
      </div>
      <div
        matTooltip="Edit default timezone in rental settings."
        matTooltipClass="text-center"
        matTooltipPosition="above"
        class="col-sm-4 prevent-timezone-edit"
      >
        <ng-select
          [items]="timezoneList"
          [selectOnTab]="true"
          [clearable]="false"
          [virtualScroll]="true"
          formControlName="timezone"
          placeholder="TimeZone:"
          class="mat-block"
        >
        </ng-select>
      </div>
    </div>

    <div class="row">
      <div
        class="offset-2 col-sm-4 check-container"
        [matTooltip]="
          form.get('checkIn').disabled
            ? 'Please set check-in/checkout-out times for current rental before you can edit check-in time'
            : ''
        "
        matTooltipClass="text-center"
        matTooltipPosition="above"
      >
        <mat-form-field class="mat-block">
          <input
            type="time"
            matInput
            atp-time-picker
            changeToMinutes="true"
            formControlName="checkIn"
            placeholder="Check-in Time"
          />
          <span matSuffix><i class="fal fa-clock"></i></span>
        </mat-form-field>
      </div>
      <div
        class="col-sm-4 check-container"
        [matTooltip]="
          form.get('checkOut').disabled
            ? 'Please set check-in/checkout-out times for current rental before you can edit check-out time'
            : ''
        "
        matTooltipClass="text-center"
        matTooltipPosition="above"
      >
        <mat-form-field class="mat-block">
          <input
            type="time"
            matInput
            atp-time-picker
            changeToMinutes="true"
            formControlName="checkOut"
            placeholder="Check-out Time"
          />
          <span matSuffix><i class="fal fa-clock"></i></span>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="offset-2 col-sm-10">
        <a
          href="javascript:;"
          matTooltip="Setting Rental Check-in/Check-out times on the rental instructions page will not update bookings already created or imported into Tokeet. Once these settings are in place newly created or imported bookings will use these times."
          matTooltipClass="text-center"
          matTooltipPosition="above"
          class="clickable"
          (click)="editRentalTimezone()"
        >
          <i class="fa fa-edit"></i> Edit Rental Check-in/Check-out times
        </a>
      </div>
    </div>
    <div class="row">
      <div [class.disabled]="inquiry.sourceType !== sourceTypes.Tokeet" class="offset-2 col-md-4">
        <mat-form-field [floatLabel]="'never'" class="mat-block">
          <mat-select formControlName="channel" placeholder="Source:" [required]="true">
            <mat-option *ngFor="let channel of channels$ | async" [value]="channel.id">{{ channel.label }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.get('channel').touched && form.get('channel').hasError('required')">
            Channel is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-outline btn-default-outline text-uppercase">
    <i class="fal fa-times"></i>
    Cancel
  </button>
  <button
    (click)="onSave(form)"
    [disabled]="isUpdatingBooking$ | async"
    type="button"
    class="btn btn-success text-uppercase"
  >
    <i class="fas fa-save"></i> Save
  </button>
</div>
